<div class="row">Risk Ratings:
  @for (rating of rollup.rankings; track rating) {
    <div style="max-width: 45px; display: flex">{{rating.key}} | <span class="ranking-block">{{rating.value}}</span></div>
  }
</div>
<h3 style="font-weight: normal">Deals</h3>
<div class="row">Closed |
  <small class="rollup-column">Count: {{rollup.closed.count}} |
    Units: {{rollup.closed.units}} |
    LIHTC Units: {{rollup.closed.lihtc_units}} |
    Total LT Equity: {{rollup.closed.total_lt_equity | currency : 'USD' : 'symbol' : '1.0-0'}} |
    Average Hard Debt: {{rollup.closed.avg_hard_debt | percent}} |
    Average LT Yield: {{rollup.closed.avg_lt_yield | percent: '1.4-4'}} |
    Average PPC: {{rollup.closed.avg_ppc | currency: 'USD': 'symbol': '1.4-4'}}
  </small>
</div>
<div class="row" style="padding-bottom: 10px">Closing |
  <small class="rollup-column">Count: {{rollup.closing.count}} |
    Units: {{rollup.closing.units}} |
    LIHTC Units: {{rollup.closing.lihtc_units}} |
    Total LT Equity: {{rollup.closing.total_lt_equity | currency: 'USD' : 'symbol' : '1.0-0'}} |
    Average Hard Debt: {{rollup.closing.avg_hard_debt | percent}} |
    Average LT Yield: {{rollup.closing.avg_lt_yield | percent: '1.4-4'}} |
    Average PPC: {{rollup.closing.avg_ppc | currency: 'USD': 'symbol': '1.4-4'}}
  </small>
</div>
<div class="row">
  <mat-paginator
    [length]="pageInfo.total"
    [pageSize]="pageInfo.perPage"
    (page)="getPage($event)"
  ></mat-paginator>
</div>
<table mat-table class="stripped-table mat-elevation-z2" [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="deal">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Deal Name</th>
    <td mat-cell *matCellDef="let row"><a href="{{row.dealUrl}}" target="_blank" class="data-link">{{row.deal}}</a></td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Deal Type</th>
    <td mat-cell *matCellDef="let row">{{row.deal_type}}</td>
  </ng-container>
  <ng-container matColumnDef="project_status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Status</th>
    <td mat-cell *matCellDef="let row">{{row.project_status}}</td>
  </ng-container>
  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
    <td mat-cell *matCellDef="let row">{{row.role}}</td>
  </ng-container>
  <ng-container matColumnDef="organization">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
    <td mat-cell *matCellDef="let row"><a href="{{row.organizationUrl}}" target="_blank" class="data-link">{{row.organization}}</a></td>
  </ng-container>
  <ng-container matColumnDef="closing_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Closing Date</th>
    <td mat-cell *matCellDef="let row">{{row.closing_date}}</td>
  </ng-container>
  <ng-container matColumnDef="risk_rating">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Risk Rating</th>
    <td mat-cell *matCellDef="let row">{{row.risk_rating}}</td>
  </ng-container>
  <ng-container matColumnDef="location">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
    <td mat-cell *matCellDef="let row">{{row.location}}</td>
  </ng-container>
  <ng-container matColumnDef="county">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
    <td mat-cell *matCellDef="let row">{{row.county}}</td>
  </ng-container>
  <ng-container matColumnDef="4%/9%">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>4%/9%</th>
    <td mat-cell *matCellDef="let row">{{row.tax_perc}}</td>
  </ng-container>
  <ng-container matColumnDef="lt_equity">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>LT Equity</th>
    <td mat-cell *matCellDef="let row">{{row.lt_equity}}</td>
  </ng-container>
  <ng-container matColumnDef="ppc">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Price Per Credit</th>
    <td mat-cell *matCellDef="let row">{{row.ppc}}</td>
  </ng-container>
  <ng-container matColumnDef="lt_yield">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>LT Yield</th>
    <td mat-cell *matCellDef="let row">{{row.lt_yield | percent: '1.4-4'}}</td>
  </ng-container>
  <ng-container matColumnDef="construction">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Construction</th>
    <td mat-cell *matCellDef="let row">{{row.construction}}</td>
  </ng-container>
  <ng-container matColumnDef="resident">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Resident</th>
    <td mat-cell *matCellDef="let row">{{row.resident}}</td>
  </ng-container>
  <ng-container matColumnDef="total_units">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Units</th>
    <td mat-cell *matCellDef="let row">{{row.total_units}}</td>
  </ng-container>
  <ng-container matColumnDef="total_lihtc">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Total LIHTC Units</th>
    <td mat-cell *matCellDef="let row">{{row.total_lihtc}}</td>
  </ng-container>
  <ng-container matColumnDef="hard_debt">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Hard Debt</th>
    <td mat-cell *matCellDef="let row">{{row.hard_debt | percent}}</td>
  </ng-container>
  <ng-container matColumnDef="outlets">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlets</th>
    <td mat-cell *matCellDef="let row">{{row.outlets}}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef=dealsColumns></tr>
  <tr mat-row *matRowDef="let row; columns: dealsColumns"></tr>
</table>
